







































import { namespace } from "vuex-class";
import { CognitoUser } from "@aws-amplify/auth";
import { Component, Mixins } from "vue-property-decorator";

import AlertList from "@/components/AlertList.vue";
import HasAlerts from "@/mixins/HasAlerts.vue";

const AuthStore = namespace("auth");

@Component({
  components: { AlertList }
})
export default class CompleteSignIn extends Mixins(HasAlerts) {
  private code: string = "";

  private status: "Loading" | "Idle" = "Idle";

  @AuthStore.State("raw")
  private user!: CognitoUser | null;

  async mounted(): Promise<void> {
    if (!this.user) await this.$router.push("/login");
  }

  async finish() {
    try {
      this.status = "Loading";

      await this.$auth.raw.confirmSignIn(
        this.user,
        this.code,
        (this.user as any).challengeName
      );

      this.$router.push("/login");
    } catch (ex) {
      this.flash(
        {
          type: "danger",
          message: ex.message || ex
        },
        { global: false }
      );
    } finally {
      this.status = "Idle";
    }
  }
}
